import { Injectable, ApplicationRef, ChangeDetectorRef, NgZone} from '@angular/core';
import { MatSnackBar} from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  InUse:boolean;

  constructor(public snackBar: MatSnackBar, private zone: NgZone ) { 
    this.InUse = false;
  }
  
  showSuccess(message: string, action : string): void {
    this.snackBar.open(message, action);
  }
  
  showError(message: string): void {
    // The second parameter is the text in the button. 
    // In the third, we send in the css class for the snack bar.
    if (this.InUse == false) {
      let snackBarRef = this.snackBar.open(message, 'Close'); 

      snackBarRef.onAction().subscribe(() => {
        this.InUse = false;
        snackBarRef.dismiss();
        this.zone.run(() => {});
      });

      this.InUse = true;
    }
  }
}